import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendProject, BackendQueryProjectArgs } from 'src/types/backend';

import { FRAGMENT_AUDIENCE_TARGET } from './schema';

const QUERY = gql`
  query QueryAudiencesTargeting($id: Int!) {
    project(id: $id) {
      continuousOptimizationSegment {
        id
        status
        keywords
        audienceTarget {
          ...AudienceTarget
        }
      }
    }
  }
  ${FRAGMENT_AUDIENCE_TARGET}
`;

type Variables = BackendQueryProjectArgs;

export const queryAudienceSegments = async (variables: Variables) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
  });

  const project = getSingleProp<BackendProject>(result.data);
  return project?.continuousOptimizationSegment ?? [];
};
